import type { V1SMOptions, V1SMSeries } from '@/lib/api/lib'
import { telemetryClient } from '@/lib/api/lib/client'
import { getUserId } from '@/lib/cookies'
import { formatUTCDate, getNowUTC } from '@/lib/date'

/**
 * An app open. Not in the generated series enum: apigateway's stats policy
 * names it, and keeps one per user and UTC day.
 */
export const VISIT = {
    series: 'v1Visits' as V1SMSeries,
    operation: 'visit' as V1SMOptions
}

const VISIT_KEY = 'stats.visit'

/**
 * Records that the caller opened the app today: it makes them active on
 * the boards. The local mark only saves the request on later opens the same
 * day. Best effort, never throws.
 */
export function recordVisit(now = new Date(getNowUTC())): void {
    const userId = getUserId()
    if (!userId) return
    const mark = `${userId}:${formatUTCDate(now)}`
    try {
        if (localStorage.getItem(VISIT_KEY) === mark) return
    } catch {
        // Storage blocked: the server still counts one a day.
    }
    telemetryClient
        .emitEvent(VISIT)
        .then(() => {
            try {
                localStorage.setItem(VISIT_KEY, mark)
            } catch {
                // Storage blocked
            }
        })
        .catch(() => {})
}
